import PropTypes from 'prop-types'

import customerObjectType from './customer-obj-type'

export default PropTypes.shape({
    id: PropTypes.string,
    funnelId: PropTypes.string,
    visualizationId: PropTypes.string,
    brutPrice: PropTypes.number,
    approved: PropTypes.bool,
    purchased: PropTypes.bool,
    ratePayAllowed: PropTypes.bool,
    rateCount: PropTypes.number,
    rateMonthly: PropTypes.number,
    prePayment: PropTypes.number,
    finalPayment: PropTypes.number,
    physicianCost: PropTypes.number,
    iprNeeded: PropTypes.bool,
    physicianZabPartner: PropTypes.bool,
    interestRate: PropTypes.number,
    treatmentDuration: PropTypes.number,
    numberOfAligner: PropTypes.number,
    numberOfStepsUpperJaw: PropTypes.number,
    numberOfStepsLowerJaw: PropTypes.number,
    numberOfAlignerUpperJaw: PropTypes.number,
    numberOfAlignerLowerJaw: PropTypes.number,
    system: PropTypes.string,
    validUntil: PropTypes.string,
    treatmentLink: PropTypes.string,
    customerName: PropTypes.string,
    commentKey: PropTypes.string,
    comment: PropTypes.string,
    created: PropTypes.string,
    referenceNumber: PropTypes.string,
    currency: PropTypes.string,
    customerId: PropTypes.string,

    customer: customerObjectType,

    videoList: PropTypes.array,
})



// WEBPACK FOOTER //
// ./src/prop-types/treatment-quotation-obj-type.js